import Gutter from './Gutter'

export default {
  name: 'gutter',
  configure: function(config) {
    config.addComponent('gutter', Gutter)
  }
}
